import React, { useState } from 'react';
import { Upload, message, Image, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import AuthService from '../utils/auth';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3060/api';

/**
 * 产品图片上传组件
 * mode="single" - 单图（封面图）
 * mode="multiple" - 多图（图集）
 */
const ProductImageUpload = ({ value, onChange, mode = 'single' }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewSrc, setPreviewSrc] = useState('');

  const handleUpload = async (options) => {
    const { file, onSuccess, onError } = options;
    const formData = new FormData();
    formData.append('image', file);

    try {
      const resp = await fetch(`${API_BASE}/upload/product-image`, {
        method: 'POST',
        headers: AuthService.getAuthHeaders(),
        body: formData
      });
      const data = await resp.json();
      if (data.success) {
        const url = data.data.url;
        if (mode === 'single') {
          onChange?.(url);
        } else {
          onChange?.([...(value || []), url]);
        }
        onSuccess(data);
      } else {
        message.error(data.message || '上传失败');
        onError(new Error(data.message));
      }
    } catch (err) {
      message.error('上传失败');
      onError(err);
    }
  };

  const handleRemove = (url) => {
    if (mode === 'single') {
      onChange?.('');
    } else {
      onChange?.((value || []).filter(v => v !== url));
    }
  };

  const handlePreview = (url) => {
    setPreviewSrc(url);
    setPreviewVisible(true);
  };

  // 单图模式
  if (mode === 'single') {
    return (
      <div>
        {value ? (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img
              src={value}
              alt="封面"
              style={{ width: 200, height: 120, objectFit: 'cover', borderRadius: 8, cursor: 'pointer' }}
              onClick={() => handlePreview(value)}
            />
            <Button
              type="text"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => handleRemove(value)}
              style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(255,255,255,0.8)' }}
            />
          </div>
        ) : (
          <Upload customRequest={handleUpload} showUploadList={false} accept="image/*">
            <div style={{
              width: 200, height: 120, border: '1px dashed #d9d9d9', borderRadius: 8,
              display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
              background: '#fafafa'
            }}>
              <PlusOutlined style={{ fontSize: 24, color: '#999' }} />
            </div>
          </Upload>
        )}
        <Image
          style={{ display: 'none' }}
          preview={{ visible: previewVisible, src: previewSrc, onVisibleChange: setPreviewVisible }}
        />
      </div>
    );
  }

  // 多图模式
  return (
    <div>
      <Space wrap>
        {(value || []).map((url, idx) => (
          <div key={idx} style={{ position: 'relative', display: 'inline-block' }}>
            <img
              src={url}
              alt={`图${idx + 1}`}
              style={{ width: 120, height: 80, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
              onClick={() => handlePreview(url)}
            />
            <Button
              type="text"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => handleRemove(url)}
              style={{ position: 'absolute', top: 2, right: 2, background: 'rgba(255,255,255,0.8)' }}
            />
          </div>
        ))}
        <Upload customRequest={handleUpload} showUploadList={false} accept="image/*">
          <div style={{
            width: 120, height: 80, border: '1px dashed #d9d9d9', borderRadius: 6,
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
            background: '#fafafa'
          }}>
            <PlusOutlined style={{ fontSize: 20, color: '#999' }} />
          </div>
        </Upload>
      </Space>
      <Image
        style={{ display: 'none' }}
        preview={{ visible: previewVisible, src: previewSrc, onVisibleChange: setPreviewVisible }}
      />
    </div>
  );
};

export default ProductImageUpload;
